import type { FC } from "react";

import { EPrimaryItemType, SubsectionItem } from "@similarweb/ui-components";

import {
    extensionPromotionSourceMap,
    getSimilarwebExtensionStoreUrl,
} from "app/UtilitiesAndConstants/UtilityFunctions/extensionStoreUrl";
import { useTrack } from "pro-features/components/WithTrack/src/useTrack";
import { allTrackers } from "app/services/track/track";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { ExtensionPromotionIndicator } from "./ExtensionPromotionIndicator";
import { useExtensionPromotionIndicator } from "./hooks/useExtensionPromotionIndicator";
import { Container } from "./styles";

interface ISimilarwebExtensionButtonProps {
    isBarOpen: boolean;
}

export const SimilarwebExtensionButton: FC<ISimilarwebExtensionButtonProps> = ({ isBarOpen }) => {
    const translate = useTranslation();
    const [track] = useTrack();
    const showPromotionIndicator = useExtensionPromotionIndicator();

    const handleClick = () => {
        track("internal link", "click", "download extension/side banner");
        allTrackers.dispatchTrackEvent("similarweb.extension", "click", "similarweb.extension");
        window.open(getSimilarwebExtensionStoreUrl(extensionPromotionSourceMap.sideBanner), "_blank");
    };

    return (
        <Container onClick={handleClick}>
            <SubsectionItem
                key="similarwebExtensionButton"
                itemText={translate("similarweb.extension.title")}
                icon="sidebar3-extension"
                itemType={EPrimaryItemType.SecondaryAction}
                isCollapsed={!isBarOpen}
            />
            {showPromotionIndicator ? <ExtensionPromotionIndicator isCollapsed={!isBarOpen} /> : undefined}
        </Container>
    );
};
